import { render, staticRenderFns } from "./ImportThaibevCategory.vue?vue&type=template&id=b26f63b4&scoped=true&"
import script from "./ImportThaibevCategory.vue?vue&type=script&lang=js&"
export * from "./ImportThaibevCategory.vue?vue&type=script&lang=js&"
import style0 from "./ImportThaibevCategory.vue?vue&type=style&index=0&id=b26f63b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b26f63b4",
  null
  
)

export default component.exports